import React, { useState } from "react";
import { Dialog, Tag, InputGroup, FormGroup, Classes, Button } from "@blueprintjs/core";
import { Trans } from 'react-i18next';

import { authenticatedPostFetch } from "../../utils/AuthenticatedFetch";
import { EquipmentSelect } from "../Structure/EquipmentSelector";

export default function AddEndpoint(props) {
    const [AddTerminal, setAddTerminal] = useState(false);
    const [name, setname] = useState(undefined);
    const [password, setpassword] = useState(undefined);
    const [CompleteAdd, setCompleteAdd] = useState(true);
    const [AssociatedEquipment, setAssociatedEquipment] = useState(undefined);

    return <div>
        <Tag
            large={true}
            round={true}
            icon="add"
            interactive={true}
            onClick={() => setAddTerminal(true)} />
        <Dialog
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            icon="add"
            isOpen={AddTerminal}
            isCloseButtonShown={true}
            onClose={() => {
                setAddTerminal(false);
                setCompleteAdd(true);
                setpassword(undefined);
                setname(undefined);
                setAssociatedEquipment(undefined);
            }}
            title={<Trans>add terminal</Trans>}>
            <div className={Classes.DIALOG_BODY}>
                <FormGroup label={<Trans>sip name</Trans>} labelFor="name-input">
                    <InputGroup
                        id="name-input"
                        onChange={(rep) => setname(rep.target.value)}
                        leftIcon="user"
                        large={true}
                        intent={"primary"} />
                </FormGroup>
                <FormGroup label={<Trans>sip password</Trans>} labelFor="password-input">
                    <InputGroup
                        id="password-input"
                        onChange={(rep) => setpassword(rep.target.value)}
                        leftIcon="lock"
                        large={true}
                        intent={"primary"} />
                </FormGroup>
                <FormGroup label={<Trans>associated equipment</Trans>} labelFor="AssociatedEquipment-input">
                    <EquipmentSelect onSelect={(id, park, server, pk) => setAssociatedEquipment(pk)} />
                </FormGroup>
            </div>
            <div className="flexbox-center">
                <FormGroup >
                    <Button
                        intent="primary"
                        onClick={() => {
                            if (name === undefined || name.trim().length === 0 || password === undefined || password.trim().length === 0 || AssociatedEquipment === undefined) {
                                setCompleteAdd(false)
                            }
                            else {
                                setCompleteAdd(true);
                                authenticatedPostFetch("/phonie/endpoint",
                                    { name: name, password: password, equipment: AssociatedEquipment },
                                    () => setAddTerminal(false));
                                setpassword(undefined);
                                setname(undefined);
                                setAssociatedEquipment(undefined);
                            }
                        }}>
                        <Trans>add</Trans>
                    </Button>
                </FormGroup>
            </div>
            {(!CompleteAdd) &&
                <Tag
                    large={true}
                    intent="warning"
                    icon="warning-sign">
                    <Trans>please fill in the fields above before validating</Trans></Tag>}
        </Dialog>
    </div>
}